import { useEffect, useState } from "react";

const PLATFORMS = [
  { icon: "ri-weibo-fill", label: "微博", cls: "text-accent-600" },
  { icon: "ri-wechat-fill", label: "微信", cls: "text-secondary-600" },
  { icon: "ri-qq-fill", label: "QQ", cls: "text-primary-600" },
  { icon: "ri-twitter-x-fill", label: "X", cls: "text-foreground-800" },
];

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  if (!open) return null;

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-primary-950/50 px-4" onClick={onClose}>
      <div
        className="w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">分享作品</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 hover:bg-background-200"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <p className="mb-5 truncate text-sm text-foreground-500">{title}</p>

        <div className="grid grid-cols-4 gap-3">
          {PLATFORMS.map((p) => (
            <button
              key={p.label}
              type="button"
              onClick={handleCopy}
              className="flex flex-col items-center gap-2 rounded-lg border border-background-200 py-3 transition-colors hover:border-secondary-300 hover:bg-background-100"
            >
              <i className={`${p.icon} text-2xl ${p.cls}`}></i>
              <span className="text-xs text-foreground-600">{p.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-2 rounded-lg border border-background-200 bg-background-100 p-2 pl-3">
          <span className="min-w-0 flex-1 truncate text-sm text-foreground-600">{shareUrl}</span>
          <button
            type="button"
            onClick={handleCopy}
            className="flex shrink-0 items-center gap-1 rounded-md bg-primary-600 px-3 py-1.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
            {copied ? "已复制" : "复制"}
          </button>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-400">
          * 分享与复制为前端功能演示，不会向社交平台发送真实内容。
        </p>
      </div>
    </div>
  );
}